<template>
  <div>
    <div class="bg">
      <navigation></navigation>
      <div class="quote-wrap">
        <p class="quotes">“It’s better to burn out than to fade away.”</p>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from "@/components/navigation.vue";
export default {
  name: "Home",
  components: {
    navigation,
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "./../sass/_nav.scss";
@import "./../sass/_start.scss";
.quotes {
  color: #fff;
  font-size: 4em;
  font-weight: 400;
  margin: 0 auto;
  padding: 20px;
  max-width: 750px;
  text-align: center;
  font-family: "Playfair Display", serif;
}
.quote-wrap {
  margin-top: 30vh;
  min-height: 100vh;
  overflow: hidden;
  text-align: center;
}
@media only screen and (max-width: 900px) {
  .quotes {
    font-size: 2em;
  }
  .quote-wrap {
    margin-top: 35vh;
    min-height: 100vh;
    overflow: hidden;
    text-align: center;
  }
}
</style>
